var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/down"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#FCF1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6287 14.1893L17.9571 10.8609C18.9334 9.88454 20.5163 9.88454 21.4926 10.8609C22.4689 11.8372 22.4689 13.4201 21.4926 14.3964L16.5429 19.3461C16.0175 19.8716 15.3164 20.1142 14.6287 20.0741C13.941 20.1142 13.2399 19.8716 12.7145 19.3461L7.7647 14.3964C6.78839 13.4201 6.78839 11.8372 7.7647 10.8609C8.74101 9.88454 10.3239 9.88454 11.3002 10.8609L14.6287 14.1893Z",
    fill: "#E37B3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4993",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 16,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6287 14.1893L17.9571 10.8609C18.9334 9.88454 20.5163 9.88454 21.4926 10.8609C22.4689 11.8372 22.4689 13.4201 21.4926 14.3964L16.5429 19.3461C16.0175 19.8716 15.3164 20.1142 14.6287 20.0741C13.941 20.1142 13.2399 19.8716 12.7145 19.3461L7.7647 14.3964C6.78839 13.4201 6.78839 11.8372 7.7647 10.8609C8.74101 9.88454 10.3239 9.88454 11.3002 10.8609L14.6287 14.1893Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 30,
    height: 30,
    fill: "#E37B3C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownV2);
export default __webpack_public_path__ + "static/media/down_v2.7f15f4fe6d43bcbcc287fc1e67a4f183.svg";
export { ForwardRef as ReactComponent };